import React, { PropTypes } from 'react';
import { Router, Link } from 'react-router';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Navbar, Nav, NavItem, Button, Glyphicon, Alert, Row, Col } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';
import LoadingBar from 'react-redux-loading-bar';
import Spinner from 'react-spinner';
import NotificationSystem from 'react-notification-system';
import objectAssign from 'object-assign';
import _ from 'lodash';

import UserLanguageSelectContainer from './UserLanguageSelectContainer';
import AutoassignContainer from './AutoassignContainer';
import OrderDetailModal from '../components/modals/OrderDetailModal';
import { gettext, setLocale } from '../i18n/service';
import * as actions from '../actions/appActions';
import * as fleetActions from '../actions/fleetOwnerActions';
import * as logoutPageActions from '../actions/logoutPageActions';
import * as adminActions from '../actions/adminActions';
import * as dashboardPageActions from '../actions/dashboardPageActions';
import * as onDemandActions from '../actions/onDemandActions';
import LoopbackHttp, { getUserType } from '../businessLogic/LoopbackHttp.js';
import getCurLang from '../businessLogic/getCurLang.js';
import { addConsult } from '../businessLogic/onlineConsult.js';
import soundNotification from '../businessLogic/soundNotification';
import * as streamHelper from '../businessLogic/streamUpdateHelper';
import { getDashboardButtonStyle } from '../businessLogic/getButtonStyle.js';
import { makePurchase, showPurchaseResults } from '../businessLogic/pay';
import { getCurrendDashboardUrl } from '../businessLogic/getCurrendDashboardUrl';
import { setDashType, getDashType } from '../businessLogic/userProfileHelper';

var lan = getCurLang();
let downloadTimer;

export class App extends React.Component {
  getInitialState() {
    return { buildNum: { build_num: 0 } };
  }
  constructor(props, context) {
    super(props, context);
    this.isDispatcher = LoopbackHttp.isDispatcher;
    this.isOperator = LoopbackHttp.isOperator;
    this.isFleet = LoopbackHttp.isFleet;
    this.showMessage = this.showMessage.bind(this);
    this.subscribeOnStreamUpdates = this.subscribeOnStreamUpdates.bind(this);
    this.handleDismiss = this.handleDismiss.bind(this);
    this.subscribeToStreamErrors = this.subscribeToStreamErrors.bind(this);
    this.isSubscribed = false;
    this.card = undefined;

    this.state = {
      showSettingsMenu: false,
      modal: undefined,
      showAlert: true,
      connectionErrorAlert: false,
      streamError: false,
      reConnectStart: false,
      remainSecond: 30,
      autoReconnect: false
    };

    if (!localStorage.getItem('sound_notifications'))
      localStorage.setItem('sound_notifications', true);
  }

  componentDidMount() {
    if (!LoopbackHttp.isAuthenticated()) {
      return;
    }
    this.props.actions.getAccount();
  }

  subscribeOnStreamUpdates = () => {
    this.isSubscribed = true;
    // this.eventStream = LoopbackHttp.subscribeOnServerEvents();
    this.setState({
      eventStream: LoopbackHttp.subscribeOnServerEvents()
    }, () => {
      this.state.eventStream.addEventListener('data', this.getDataFromStream);
      this.subscribeToStreamErrors();
    });
  }

  subscribeToStreamErrors = () => {
    this.setState({ streamError: false })
    const { connectionErrorAlert, reConnectStart, streamError } = this.state;
    const {actions} = this.props;

    this.state.eventStream.onerror = () => {
      this.setState({
        reConnectStart: true,
        streamError: true,
        connectionErrorAlert: true
      }, this._throttledReconnect)
    }
  }

  _throttledReconnect = _.throttle(() => {
    streamHelper.connectionError(this.showMessage);

    setInterval(() => {
      this.setState({remainSecond: this.state.remainSecond - 1}, () => {
        if (this.state.remainSecond === 0) this.reconnect();
      })
    }, 1000)
  }, 30000)

  getDataFromStream = (msg) => {
    let { pickUpPoints, saveItemToTemp, updateLocalDriver, addNewOrderToStore, updateLocalDriverLocation, updateLocalRecipient, addNewTeamToStore, updateLocalTeam, updateLocalOrder, addNewUserToStore, updateLocalUser, addNewGroupageToStore, updateLocalGroupage, addNewRecipientToStore, addNewPickUpPointToStore, updateLocalPickUpPoint, getPickUpPoint } = this.props.actions;
    let data = JSON.parse(msg.data);

    let commonParamets = [data, this.showMessage, this.props.router, this.renderModalForDetails];
    if (data.model === 'Card') {
      if (data.data.confirmed === true || data.data.confirmed === false)
        streamHelper.createCard(data, this.showMessage);
    }
    if (data.model === 'Order') {
      if (data.type === 'create') {
        streamHelper.createOrder(...commonParamets, addNewOrderToStore);
        // _.map(data.data.order.items, (item) => {
        //   this.props.actions.getPickUpPoint(item.pickupPointId)
        // })
      } else if (data.type === 'update') {
        console.log('updated')
        this.props.onDemandActions.getAllOrdersForCompany(this.props.company.id);
        streamHelper.updateOrder(...commonParamets, updateLocalOrder, this.props.orders, this.props.users, this.props.drivers)
      }
    } else if (data.model === 'Item') {
      if (data.type === 'create') {
        const order = _.find(this.props.orders, { id: data.data.orderId });
        this.props.actions.getPickUpPoint(data.data.pickupPointId)
        if (!order) {
          return saveItemToTemp(data.data);
        }
        let orderItems = order.items || [];
        if (_.some(order.items, { id: data.data.id })) {
          return;
        }
        this.props.actions.getPickUpPoint(data.data.pickupPointId)
        return updateLocalOrder(order, { items: orderItems.concat([data.data]) });
      } else if (data.type === 'update') {
        const order = _.find(this.props.orders, { id: data.data.orderId });
        if (!order) {
          return;
        }
        let orderItems = objectAssign([], order.items);
        let item = _.find(orderItems, { id: data.data.id });
        objectAssign(item, data.data);
        return updateLocalOrder(order, { items: orderItems });
      }
    } else if (data.model === 'Company') {
      if (data.type === 'update') {
        this.props.adminActions.updateLocalCompany(data.data.id, data.data);
      }
    } else if (data.model === 'PickUpPoint') {
      if (data.type === 'create') {
        addNewPickUpPointToStore(data.data);
      } else if (data.type === 'update') {
        updateLocalPickUpPoint(data.data);
      }
    } else if (data.model === 'Driver' || data.model === 'Dispatcher' || data.model === 'Operator') {
      if (data.type === 'create') {
        addNewUserToStore(data.data);
      } else if (data.type === 'update') {
        updateLocalDriver(data.data);
      }
    } else if (data.model === 'Recipient') {
      if (data.type === 'create') {
        addNewRecipientToStore(data.data);
      } else if (data.type === 'update') {
        return updateLocalRecipient(data.data);
      }
    }
    // else if (data.model === 'DriverGpsLocation') {
    //   console.log('hi')
    //   if (data.type === 'update') {
    //     return updateLocalDriverLocation(data.data);
    //   }
    // } else if (data.model === 'GpsLog') {
    //   console.log('GpsLog stream update', data.data)
    //     return updateLocalDriverLocation(data.data);
    // }
    else if (data.model === 'Team') {
      if (data.type === 'create') {
        addNewTeamToStore(data.data);
      } else if (data.type === 'update') {
        updateLocalTeam(data.data);
      }
    }
  }

  componentWillReceiveProps(nextProps) {
    // if (!LoopbackHttp.isAuthenticated()) {
    //   this.props.actions.endSpinner();
    //   return;
    // }

    if (nextProps.message) {
      this.showMessage(nextProps.message);
    }

    if (localStorage.getItem('userType') === 'driver') {
      this.props.logoutPageActions.logout();
    }

    if (nextProps.redirectAfterLogin && this.props.account.id) {
      this.props.actions.startSpinner();
      this.props.actions.getAccount();
      this.isAuthenticated = true;
    }

    if (nextProps.account !== this.props.account) {
      if (nextProps.account.dashboardType && nextProps.account.dashboardType !== getDashType())
        setDashType(nextProps.account.dashboardType);

      if (LoopbackHttp.isFleet)
        this.props.actions.getCompany(nextProps.account.id);
      else
        this.props.actions.getCompany(nextProps.account.companyId);
    }
    // if (nextProps.connectionError && nextProps.connectionError !== this.props.connectionError) {
    //   streamHelper.connectionError(this.showMessage);
    // }
    if (!this.isSubscribed && LoopbackHttp.isAuthenticated()) {
      this.subscribeOnStreamUpdates();
    }
  }

  renderModalForDetails = (order, canUnassign, unassignOrder) => {
    this.setState({
      modal: (<OrderDetailModal
        order={order}
        key={order.id}
        vehicles={this.props.vehicles}
        router={this.props.router}
        showMessage={this.showMessage}
        actions={this.props.actions}
        cancelOrder={this.props.dashboardPageActions.cancelOrder}
        show={true}
        clearModalFromState={this.clearModalFromState}
        canUnassign={canUnassign}
        unassignOrder={this.props.dashboardPageActions.unassignOrder} />)
    });
  }

  clearModalFromState = () => {
    this.setState({ modal: undefined });
  }

  showMessage(opts) {
    this.props.actions.clearMessage();
    if (this._notificationSystem) {
      this._notificationSystem.addNotification(opts);
      return;
    }

    if (this.__notificationSystem) {
      this.__notificationSystem.addNotification(opts);
      return;
    }

    if (this.__notificationSystem) {
      this.__notificationSystem.addNotification(opts);
      return;
    }
  }

  toggleSettingsMenu() {
    this.setState({ showSettingsMenu: !this.state.showSettingsMenu });
  }

  calculateActiveOrders() {
    const { orders } = this.props;
    if (orders && orders.length) {
      let count = 0;
      for (let i = 0; i < orders.length; i++) {
        if (orders[i].orderStatus !== 'returned' && orders[i].orderStatus !== 'canceled' && orders[i].orderStatus !== 'delivered') {
          count++;
        }
      }
      return count;
    } else {
      return 0;
    }
  }

  handleDismiss() {
    this.setState({ showAlert: false });
  }

  reconnect() {
    // clearInterval(downloadTimer);
    // this.setState({ reConnectStart: true, autoReconnect: true });
    // this.subscribeOnStreamUpdates();
    window.location.reload()
  }

  render() {
    const isAuthenticated = LoopbackHttp.isAuthenticated();
    const isDispatcherActive = LoopbackHttp.isUserActive();
    const navLinksForDispatcher = [];

    if (LoopbackHttp.isDispatcher) {
      if (isDispatcherActive) {
        navLinksForDispatcher.push(
          <LinkContainer key="navLinkDDashboard" to="/dispatcherDashboard">
            <NavItem eventKey={1}>
              {gettext('DISPATCHER.DISPATCHER-DASHBOARD')}
            </NavItem>
          </LinkContainer>
        );
        navLinksForDispatcher.push(
          <LinkContainer key="navLinkSettings" to="/settings">
            <NavItem eventKey={5}>
              {gettext('SETTINGS')}
            </NavItem>
          </LinkContainer>
        );
      }
      else {
        navLinksForDispatcher.push(
          <LinkContainer key="navLinkConfirmation" to="/Confirmation">
            <NavItem eventKey={1}>
              {'Confirmation'}
            </NavItem>
          </LinkContainer>
        );
      }
    }
    const navLinksForOperator = [];
    if (LoopbackHttp.isOperator || LoopbackHttp.isAdministrator) {
      navLinksForOperator.push(
        <LinkContainer key="navLinkDashboard" to="/dashboard">
          <NavItem eventKey={1}>
            {LoopbackHttp.isAdministrator ? gettext('ADMIN.ADMIN-DASHBOARD') : ''}
            {LoopbackHttp.isOperator ? gettext('OPERATOR.OPERATOR-DASHBOARD') : ''}
          </NavItem>
        </LinkContainer>
      );

      navLinksForOperator.push(
        <LinkContainer key="navLinkSettings" to="/settings">
          <NavItem eventKey={5}>
            {gettext('SETTINGS')}
          </NavItem>
        </LinkContainer>
      );
    }

    const navLinksForFleet = [];
    if (LoopbackHttp.isFleet) {
      navLinksForFleet.push(
        <LinkContainer key="navLinkDashboard" to="/fleetOwnerDashboard">
          <NavItem eventKey={1}>
            {gettext('FLEET.FLEET-DASHBOARD')}
          </NavItem>
        </LinkContainer>
      );

      navLinksForFleet.push(
        <LinkContainer key="navLinkOnDemand" to="/onDemandDashboard">
          <NavItem eventKey={2}>
            OnDemand Dashboard
          </NavItem>
        </LinkContainer>
      );

      navLinksForFleet.push(
        <LinkContainer key="navLinkSettings" to="/settings">
          <NavItem eventKey={5}>
            {gettext('SETTINGS')}
          </NavItem>
        </LinkContainer>
      );
    }
    const { showHeadersInfo } = this.props;
    const { connectionErrorAlert } = this.state;
    let canILoad = false;
    if ((LoopbackHttp.isFleet || LoopbackHttp.isOperator) && this.props.company.id)
      canILoad = true;
    else if (LoopbackHttp.isDispatcher)
      canILoad = true;
    else if (!getUserType() || getUserType() === 'guest')
      canILoad = true

    return canILoad ? (
      <div>
        <LoadingBar className="loader_bar" updateTime={1000} maxProgress={100} progressIncrease={4} />

        <div className={this.props.loaded ? "spinner" : "spinnerActive"}>
          <Spinner />
        </div>
        {document.location.href.indexOf('recipient') === -1 ?
          <Row>
            <Col sm={12} className="alert-section">
              {
                showHeadersInfo && this.state.showAlert && this.props.company.license == 'trial' ?
                  <Alert bsStyle="danger" onDismiss={this.handleDismiss}>
                    Your {this.props.company.license} ends in {this.props.company.trialDays} days.
                    Add your credit card in <Link to="/addCard">Billing</Link> to avoid service disruption.
                  </Alert>
                  : null
              }
            </Col>
            <Col sm={12} className="alert-section">
              {
                connectionErrorAlert && showHeadersInfo ?
                  <div>
                    <Alert bsStyle="danger">
                      Connect to the server is lost.
                      <a className="btn-connect" onClick={this.reconnect.bind(this)}>Reconnect</a> in {this.state.remainSecond}s...
                    </Alert>
                    <div className={"spinnerActive"}>
                      <Spinner />
                    </div>
                  </div>
                  : null
              }
            </Col>
            <Col sm={12}>
              <Navbar>
                {LoopbackHttp.isFleet ?
                  <div>
                    <label className="autoassign_header_switcher autoassign_header_switcher_label">{gettext('AUTO-ASSIGN')}</label>

                    <div className="autoassign_header_switcher">
                      <AutoassignContainer />
                    </div>
                  </div> : ''
                }
                {
                  !LoopbackHttp.isDispatcher && LoopbackHttp.isAuthenticated() ?
                    <Navbar.Brand>
                      <img src="./logo.svg" onClick={() => {
                        if (this.props.account) {
                          this.props.router.push('/')
                        }
                      }} />
                    </Navbar.Brand> : ''
                }
                {
                  showHeadersInfo ?
                    <Nav pullRight className="settings_link">
                      <NavItem>
                        <img src="./newOrder.svg" onClick={() => this.props.router.push('/createNewOrder')} />
                      </NavItem>
					  {
						  !LoopbackHttp.isDispatcher && LoopbackHttp.isAuthenticated() ?
						  <NavItem>
								<img src="./analytics.svg" onClick={() => {
									if (this.props.account) {
										this.props.router.push('/analytics')
									}
								}}/>
						  </NavItem> : ''
					  }
                      <NavItem>
                        <LinkContainer key="navLinkSettings" to="/settings">
                          <img src="./settings.svg" width="18px" height="18px" />
                        </LinkContainer>
                      </NavItem>
                      <NavItem>
                        <img src="./logout.svg"
                          onClick={() => {
                            this.props.logoutPageActions.logout();
                            location.href = "/";
                          }} />
                      </NavItem>
                    </Nav> : null
                }
                <Nav>
                  {
                    (showHeadersInfo && isDispatcherActive != 'true') ? <NavItem>
                      <div className="orders_active">
                        {this.calculateActiveOrders()}
                      </div>
                      {gettext('ACTIVE-ORDERS')}
                    </NavItem> : null
                  }

                  {
                    (showHeadersInfo && isDispatcherActive != 'true') ? <NavItem>
                      <div className="drivers_assigned">
                        {this.props.drivers.length}
                      </div>
                      {gettext('DRIVER-ACTIVE')}
                    </NavItem> : null
                  }
                </Nav>
              </Navbar>
            </Col>
          </Row>
          : null
        }
        <NotificationSystem ref={(it) => {
          if (!it || this._notificationSystem) {
            return;
          }
          this._notificationSystem = it;
        }} />
        {React.cloneElement(this.props.children, {
          showMessage: this.showMessage,
          renderModalForDetails: this.renderModalForDetails
        })}
        {this.state.modal}
      </div>
    )
      : (
        <div>
          <Row>
            <Col sm={12} className="alert-section">
              {
                connectionErrorAlert && showHeadersInfo ?
                  <div>
                    <Alert bsStyle="danger">
                      Connect to the server is lost.
                      <a className="btn-connect" onClick={this.reconnect.bind(this)}>Reconnect</a> in {this.state.remainSecond}s...
                    </Alert>
                    <div className={"spinnerActive"}>
                      <Spinner />
                    </div>
                  </div>
                  : null
              }
            </Col>
          </Row>
          <NotificationSystem ref={(it) => {
            if (!it || this.___notificationSystem) {
              return;
            }
            this.__notificationSystem = it;
          }} />
        </div>
      );
  }
}

App.propTypes = {
  account: PropTypes.object,
  actions: PropTypes.object.isRequired,
  children: PropTypes.element,
  orders: PropTypes.array,
  redirectAfterLogin: PropTypes.bool,
  loaded: PropTypes.bool
};

function mapStateToProps(state) {
  return {
    users: state.appReducer.users,
    drivers: _.filter(state.dashboardPageReducer.drivers, { driverStatus: 'active' }),
    orders: state.appReducer.orders,
    companyOrders: state.appReducer.companyOrders,
    account: state.appReducer.account,
    connectionError: state.appReducer.connectionError,
    redirectAfterLogin: state.loginFormReducer.redirect,
    loaded: state.appReducer.loaded,
    subscribed: state.appReducer.subscribed,
    cards: state.appReducer.cards,
    company: state.appReducer.company,
    bills: state.appReducer.bills,
    fortResponse: state.appReducer.fortResponse,
    showHeadersInfo: state.appReducer.showHeadersInfo,
    message: state.appReducer.message,
    clientIp: state.appReducer.clientIp,
    pickUpPoints: state.appReducer.pickUpPoints,
    pointsToFetch: state.appReducer.pointsToFetch,
    vehicles: state.appReducer.vehicles
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(actions, dispatch),
    fleetActions: bindActionCreators(fleetActions, dispatch),
    logoutPageActions: bindActionCreators(logoutPageActions, dispatch),
    adminActions: bindActionCreators(adminActions, dispatch),
    dashboardPageActions: bindActionCreators(dashboardPageActions, dispatch),
    onDemandActions: bindActionCreators(onDemandActions, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(App);



// WEBPACK FOOTER //
// ./src/containers/App.js